module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 mt-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('traffic/tasks')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "file-plus",
      "classname": "report-box__icon text-theme-10"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.tasks.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Tareas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('traffic/campaigns')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "file",
      "classname": "report-box__icon text-theme-11"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.campaigns.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Campañas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('traffic/accounts')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "folder",
      "classname": "report-box__icon text-theme-12"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.accounts.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Cuentas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('users')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "user",
      "classname": "report-box__icon text-theme-9"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.users.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Usuarios")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex items-center h-10"
  }, [_c('h2', {
    staticClass: "text-lg font-medium truncate mr-5"
  }, [_vm._v("\n                  Reporte General\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f2314a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/dashboard/Dashboard.vue
// module id = 457
// module chunks = 1